import { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";
import tokenNotFound from "./config/tokenNotFound";
import { UpdateCommentRequest, UpdateCommentResponse } from "../../api/board_comment";

export type TApiPutBoardComment = {
  result?: UpdateCommentResponse;
};

export const putBoardComment = async (
    body: UpdateCommentRequest
): Promise<TApiResult & TApiPutBoardComment> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;
  return await client()
    .board_comment.put({
      body,
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "putBoardComment");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
